import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
type KnownEventName = keyof WindowEventMap | keyof DocumentEventMap | keyof HTMLElementEventMap;
type EventForName<K extends string> = K extends keyof WindowEventMap ? WindowEventMap[K] : K extends keyof DocumentEventMap ? DocumentEventMap[K] : K extends keyof HTMLElementEventMap ? HTMLElementEventMap[K] : Event;
const useEventListener = (eventName, handler, element, options) => {
  const $ = _c(11);
  const savedHandler = useRef(handler);
  let t0;
  let t1;
  if ($[0] !== handler) {
    t0 = () => {
      savedHandler.current = handler;
    };
    t1 = [handler];
    $[0] = handler;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useIsomorphicLayoutEffect(t0, t1);
  let t2;
  if ($[3] !== element?.current || $[4] !== eventName || $[5] !== options) {
    t2 = () => {
      const targetElement = element?.current ?? window;
      if (!targetElement?.addEventListener) {
        return;
      }
      const listener = event => savedHandler.current(event as EventForName<K>);
      targetElement.addEventListener(eventName, listener, options);
      return () => {
        targetElement.removeEventListener(eventName, listener, options);
      };
    };
    $[3] = element?.current;
    $[4] = eventName;
    $[5] = options;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== element || $[8] !== eventName || $[9] !== options) {
    t3 = [eventName, element, options];
    $[7] = element;
    $[8] = eventName;
    $[9] = options;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
};
export default useEventListener;